import { ImageUpload } from '../components/ImageUpload';
import { Workout, User } from '../api/client';
import { haptic } from '../lib/telegram';
import './UploadWorkout.css';

interface UploadWorkoutProps {
  user: User;
  onBack: () => void;
  onWorkoutCreated: (workout: Workout) => void;
}

export const UploadWorkout: React.FC<UploadWorkoutProps> = ({ user, onBack, onWorkoutCreated }) => {
  return (
    <div className="upload-workout-page">
      <header className="page-header">
        <button className="back-button" onClick={() => { haptic.medium(); onBack(); }}>←</button>
        <div>
          <p className="page-eyebrow">Новая тренировка</p>
          <h1>Импорт отчёта</h1>
        </div>
      </header>

      <ImageUpload
        userId={user.id}
        onWorkoutCreated={onWorkoutCreated}
        onCancel={onBack}
      />
    </div>
  );
};
